import { motion } from "framer-motion";
import { useState } from "react";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { CLINIC } from "@/lib/assets";

const ease = [0.76, 0, 0.24, 1];

export const Testimonials = () => {
    const [i, setI] = useState(0);
    const t = CLINIC.testimonials;
    const prev = () => setI((i - 1 + t.length) % t.length);
    const next = () => setI((i + 1) % t.length);

    return (
        <section
            id="voices"
            className="py-24 md:py-36 px-6 md:px-10 bg-surya-bg relative z-[2]"
            data-testid="testimonials-section"
        >
            <div className="mx-auto max-w-[1600px]">
                <div className="grid grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-20 items-end">
                    <div className="col-span-12 md:col-span-2">
                        <div className="label text-surya-muted">Chapter</div>
                        <div className="chapter-num text-[3rem] md:text-[4.5rem] leading-none text-surya-ink mt-1">
                            04<span className="text-surya-orange">.</span>
                        </div>
                        <div className="label text-surya-muted">The Voices</div>
                    </div>
                    <div className="col-span-12 md:col-span-8 md:col-start-4">
                        <h2 className="font-serif text-surya-ink text-[clamp(2rem,4.5vw,4rem)] leading-[0.95] tracking-[-0.02em] font-light">
                            What Ranchi says about{" "}
                            <span className="italic-display text-surya-orange">
                                Surya.
                            </span>
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
                    <div className="col-span-12 md:col-span-1">
                        <Quote
                            className="h-10 w-10 md:h-14 md:w-14 text-surya-orange"
                            strokeWidth={1}
                        />
                    </div>
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease }}
                        className="col-span-12 md:col-span-9"
                    >
                        <blockquote className="font-serif text-surya-ink text-[clamp(1.6rem,3.4vw,3.2rem)] font-light leading-[1.08] tracking-[-0.01em]">
                            &ldquo;{t[i].quote}&rdquo;
                        </blockquote>
                        <div className="mt-8 md:mt-12 flex flex-wrap items-center gap-6 md:gap-10 border-t border-surya-line pt-6">
                            <div>
                                <div className="label text-surya-muted mb-1">
                                    Patient
                                </div>
                                <div className="font-serif text-surya-ink text-xl">
                                    {t[i].author}
                                </div>
                            </div>
                            <div>
                                <div className="label text-surya-muted mb-1">
                                    Neighbourhood
                                </div>
                                <div className="font-serif text-surya-ink text-xl italic-display">
                                    {t[i].place}
                                </div>
                            </div>
                            <div>
                                <div className="label text-surya-muted mb-1">
                                    Treatment
                                </div>
                                <div className="font-serif text-surya-ink text-xl">
                                    {t[i].treatment}
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <div className="col-span-12 md:col-span-2 flex md:flex-col items-start justify-between md:justify-start gap-6">
                        <div className="label text-surya-muted">
                            {String(i + 1).padStart(2, "0")} /{" "}
                            {String(t.length).padStart(2, "0")}
                        </div>
                        <div className="flex items-center gap-2">
                            <button
                                onClick={prev}
                                data-testid="testimonial-prev"
                                className="h-11 w-11 border border-surya-line hover:border-surya-orange hover:text-surya-orange flex items-center justify-center"
                                aria-label="Previous testimonial"
                            >
                                <ArrowLeft className="h-4 w-4" strokeWidth={1.4} />
                            </button>
                            <button
                                onClick={next}
                                data-testid="testimonial-next"
                                className="h-11 w-11 border border-surya-line hover:border-surya-orange hover:text-surya-orange flex items-center justify-center"
                                aria-label="Next testimonial"
                            >
                                <ArrowRight className="h-4 w-4" strokeWidth={1.4} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
